import type { TileConcreteDisplayProps } from '../../../types/rendering.js';
import { CanvasHexagonRenderer } from '../renderers/CanvasHexagonRenderer.js';

export const CanvasHexagonDisplay = (props: TileConcreteDisplayProps) => {
  const {
    center: { x, y },
    fillColor,
    width,
    radius,
    value,
    name,
    truncationMode,
    labelsDisplay,
  } = props;

  return (
    <CanvasHexagonRenderer
      x={x}
      y={y}
      width={width}
      fillColor={fillColor}
      radius={radius}
      value={value}
      name={name}
      strokeColor="transparent"
      truncationMode={truncationMode}
      labelsDisplay={labelsDisplay}
    />
  );
};

CanvasHexagonDisplay['displayName'] = 'CanvasHexagonDisplay';
